import api from '../../../lib/api'
import type {
  CustomerDetail,
  CustomerListResponse,
  MergeRequest,
  MergeResponse,
  SplitRequest,
  SplitResponse,
} from '../../../types'

export const customerService = {
  async list(params?: {
    search?: string
    page?: number
    page_size?: number
  }): Promise<CustomerListResponse> {
    const res = await api.get('/customers', { params })
    return res.data
  },

  async getById(id: number): Promise<CustomerDetail> {
    const res = await api.get(`/customers/${id}`)
    return res.data
  },

  async merge(canonicalId: number, body: MergeRequest): Promise<MergeResponse> {
    const res = await api.post(`/customers/${canonicalId}/merge`, body)
    return res.data
  },

  async split(customerId: number, body: SplitRequest): Promise<SplitResponse> {
    const res = await api.post(`/customers/${customerId}/split`, body)
    return res.data
  },

  async backfill(): Promise<{ customers_created: number; vehicles_created: number; leads_linked: number }> {
    const res = await api.post('/customers/backfill')
    return res.data
  },
}
